import React from "react";
import { Route } from "react-router-dom";
import Password from 'views/Password'

// const KEY = 'uq8^%NAyfw*uD9KH'



function ProtectedRoute({ component: Component, ...restOfProps }) {
  const isAuthenticated = true

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Password />
      }
    />
  );
}

export default ProtectedRoute;